module.exports = {
  "id": "68a463de-6dcb-4587-a2b3-5194fe892bd0",
  "gtmIds": [
    "GTM-KWTD72XK",
    "GTM-5D4DMJHZ",
    "GTM-T2TNT6",
    "GTM-KKS578WK"
  ],
  "startTracking": "after_accepting_cookies",
  "hasInAppVersion": true,
  "group": "moreys",
  "language": "en-US",
  "defaultDateFormat": "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL",
  "defaultNumberFormat": null,
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "en-US"
  ],
  "website": "https://www.moreyspiers.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}